import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
import { Badge } from 'react-bootstrap';
import noUserImg from '../assets/images/no_user.png';
const BrandProjects = ({ brandId }) => {
    const { accessToken } = useAuth();
    const [projects, setProjects] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/BrandBookRoutes/fetch-all-projects?brand_id=${brandId}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                setProjects(response.data.projects || []);
            } catch (error) {
                console.error("Error fetching projects:", error);

            } finally {
                setLoading(false);
            }
        };

        if (brandId) {
            fetchProjects();
        }
    }, [brandId, accessToken]);


    const handleCardClick = (projectId) => {
        navigate(`/Graphe/dashboard/projects_details/${projectId}`);
    };

    return (
        <Card className="view-card">
            <Card.Header className="h6 border-0 bg-light">
                Projects
            </Card.Header>
            <Card.Body className="p-0 pb-2">
                {loading ? (
                    <p className="text-center p-3">Loading...</p>
                ) : projects.length === 0 ? (
                    <p className="text-center p-3">No projects available.</p>
                ) : (
                    <ul className="brProjectlist">
                        {projects.map((project) => (
                            <li key={project.project_id} onClick={() => handleCardClick(project.project_id)} style={{ cursor: "pointer" }}>
                                <Card className="shadow-sm">
                                    <Card.Header className="h6 bg-light overflow-hidden d-flex justify-content-between">
                                        <span className="d-block ps-3" style={{ fontSize: '14px' }}>
                                            <small className="d-block text-secondary mb-1" style={{ fontSize: '12px' }}>Project Name:</small>
                                            {project.project_name}
                                        </span>
                                        <Badge
                                            className={`bg-${project.priority === "High" ? "danger" : project.priority === "Medium" ? "warning" : "success"}`}
                                            style={{ fontSize: '12px' }}>
                                            {project.priority}
                                        </Badge>
                                    </Card.Header>
                                    <Card.Body className="pt-2 pb-0 d-flex justify-content-between">
                                        {/* Leader */}
                                        <p>
                                            <small className="d-block text-secondary mb-1" style={{ fontSize: '13px' }}>Leader</small>
                                            <span className="d-flex align-items-center">
                                                <Avatar
                                                    image={project.lead?.profileImage?.image_url || noUserImg}
                                                    shape="circle"
                                                    data-pr-tooltip={`${project.lead?.first_name} ${project.lead?.last_name}`}
                                                />
                                                <Tooltip target=".p-avatar" />
                                            </span>
                                        </p>

                                        {/* Members */}
                                        <p>
                                            <small className="d-block text-secondary mb-1" style={{ fontSize: '13px' }}>Members</small>
                                            <span className="d-flex align-items-center">
                                                <AvatarGroup>
                                                    {project.members?.map(member => (
                                                        <Avatar
                                                            key={member.user_id}
                                                            image={member.profileImage?.image_url || noUserImg}
                                                            shape="circle"
                                                            data-pr-tooltip={`${member.first_name} ${member.last_name}`}
                                                        />
                                                    ))}
                                                </AvatarGroup>
                                                <Tooltip target=".p-avatar" />
                                            </span>
                                        </p>
                                    </Card.Body>
                                    <Card.Footer className="d-flex justify-content-between pt-0 border-0">
                                        <p className="mb-0 text-primary">
                                            <small className="d-block text-secondary" style={{ fontSize: '12px' }}>Created</small>
                                            <small style={{ fontSize: '12px' }}>{new Date(project.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</small>
                                        </p>
                                        <p className="mb-0 text-danger">
                                            <small className="d-block text-secondary" style={{ fontSize: '12px' }}>Deadline</small>
                                            <small style={{ fontSize: '12px' }}>{new Date(project.end_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</small>
                                        </p>
                                    </Card.Footer>
                                </Card>
                            </li>
                        ))}
                    </ul>
                )}
            </Card.Body>
        </Card>
    );
};


export default BrandProjects;
